const CATEGORY_IMAGES = {
  'Business & Management':        'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=650&h=345&fit=crop&q=80',
  'Health & Social Care':         'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=650&h=345&fit=crop&q=80',
  'Education & Training':         'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=650&h=345&fit=crop&q=80',
  'IT & Technology':              'https://images.unsplash.com/photo-1518770660439-4636190af475?w=650&h=345&fit=crop&q=80',
  'Occupational Health & Safety': 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=650&h=345&fit=crop&q=80',
  'Law':                          'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=650&h=345&fit=crop&q=80',
  'Early Years & Childcare':      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=650&h=345&fit=crop&q=80',
};
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=650&h=345&fit=crop&q=80';

// Maps snake_case API/Supabase fields to the camelCase the frontend components expect
export function normalizeCourse(rawCourse) {
  if (!rawCourse) return null;

  const modules = Array.isArray(rawCourse.modules) ? rawCourse.modules : [];
  const paymentPlans = Array.isArray(rawCourse.paymentPlans)
    ? rawCourse.paymentPlans
    : Array.isArray(rawCourse.payment_plans)
      ? rawCourse.payment_plans
      : [];

  const entryRequirements = Array.isArray(rawCourse.entryRequirements)
    ? rawCourse.entryRequirements
    : Array.isArray(rawCourse.entry_requirements)
      ? rawCourse.entry_requirements
      : [];

  const category = rawCourse.category ?? '';
  const image = rawCourse.image || rawCourse.image_url
    || CATEGORY_IMAGES[category]
    || DEFAULT_IMAGE;

  return {
    ...rawCourse,
    image,
    modules,
    paymentPlans,
    entryRequirements,
    whoIsFor: rawCourse.whoIsFor ?? rawCourse.who_is_for ?? '',
    assessment: rawCourse.assessment ?? '',
    progression: rawCourse.progression ?? '',
    onSale: rawCourse.onSale ?? rawCourse.on_sale ?? false,
    originalPrice: Number(rawCourse.originalPrice ?? rawCourse.original_price ?? 0) || null,
    price: Number(rawCourse.price) || 0,
    awardingBody: rawCourse.awardingBody ?? rawCourse.awarding_body ?? '',
    enrollCount: rawCourse.enrollCount ?? rawCourse.enroll_count ?? 0,
    reviewCount: rawCourse.reviewCount ?? rawCourse.review_count ?? 0,
    installmentEnabled: rawCourse.installment_enabled !== false && rawCourse.installmentEnabled !== false,
    createdAt: rawCourse.createdAt ?? rawCourse.created_at ?? null,
    updatedAt: rawCourse.updatedAt ?? rawCourse.updated_at ?? null,
  };
}
